<template>
  <suc-select-component
    :title="$t('components.fields.employee.title')"
    :options="options"
    label="fullName"
    :form="form"
    :name="name"
  >
    <template #no-options>{{ $t("components.fields.no_options") }}</template>
  </suc-select-component>
</template>

<script>
import { SucSelectComponent, SUC_SELECT_CHANGED_EVENT, Form } from "@/components/form";

import api from "@/api/user";

export default {
  components: {
    SucSelectComponent,
  },
  props: {
    initValue: {
      type: String,
    },
    name: {
      type: String,
      required: true,
    },
    form: {
      type: Form,
      required: true,
    },
    departmentCode: {
      type: String,
      default: null,
    },
    establishmentCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      options: [],
      value: null,
    };
  },
  created() {
    this.init();
  },
  watch: {
    departmentCode(newVal, oldVal) {
      console.log("Department code changed from", oldVal, "to", newVal);
      // Clear current selection when filters change
      this.form[this.name] = null;
      this.init();
    },
    establishmentCode(newVal, oldVal) {
      console.log("Establishment code changed from", oldVal, "to", newVal);
      // Clear current selection when filters change
      this.form[this.name] = null;
      this.init();
    },
  },
  methods: {
    async init() {
      const { data } = await api.getResponsibleEmployees();
      console.log("Employee API Response:", data);
      console.log("Employee data length:", data.length);
      console.log("Employee data structure:", data.length > 0 ? data[0] : "No data");
      console.log("Filtering with departmentCode:", this.departmentCode);
      console.log("Filtering with establishmentCode:", this.establishmentCode);

      // Filter employees based on department and/or establishment
      this.options = data.filter((employee) => {
        let matchesDepartment = true;
        let matchesEstablishment = true;

        // Filter by department if departmentCode is provided
        if (this.departmentCode) {
          matchesDepartment = employee.departmentCode === this.departmentCode;
        }

        // Filter by establishment if establishmentCode is provided
        if (this.establishmentCode) {
          matchesEstablishment = employee.establishmentCode === this.establishmentCode;
        }

        return matchesDepartment && matchesEstablishment;
      });

      console.log("Filtered employees:", this.options);
      console.log("Filtered employees length:", this.options.length);

      if (this.$isset(this.initValue)) {
        this.onChangeField(this.options.find((x) => x.employeeCode == this.initValue));
      }
    },
    onChangeField(option) {
      this.form[this.name] = option;
      this.$emit(SUC_SELECT_CHANGED_EVENT, this.$deepCopy(this.value));
    },
  },
};
</script>

<style scoped></style>
